import DashboardAlerts from "@/components/dashboard/DashboardAlerts.vue";
import { isMonitoringEnabled } from "@/services/config";

const dashboardAlertsRoutes = [
  {
    path: "/dashboard-alerts",
    name: "dashboard-alerts",
    meta: {
      enabled: isMonitoringEnabled,
    },
    component: DashboardAlerts,
  },
];

export default dashboardAlertsRoutes;
